import React from "react"
import {
    Steps,
    Button,
    message,
    SuiNumber,
    SuiInput,
    SuiSelect,
    SuiForm,
} from "@sudy/sui-react"
import postStore from "../../stores/postStore"
import urls from "../../util/urls"
import $ from "jquery"

const baseurl = window.baseurl || "";
const subPath = window.subPath || "";

class BindEmail extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            current: 0,
            code: null,
            codeUrl:"",
            icon:"",
            wechat:false
        }
    }

    /**
     * 查询微信绑定状态
     */
    getBindState(){
        const _this = this
        $.ajax({
            url: urls.getBindState,
            type: "get",
            dataType: "json",
            success: function (response) {
                if (
                    response.resultCode === 0 &&
                    response.result.data 
                    &&
                    response.result.data.state
                ) {
                    _this.setState({
                        flag: response.result.data.state,
                    })
                } else {
                    // message.warning(response.errorMsg)
                }
            },
            error: function (xhr) {
                // message.warning("请求异常")
            },
            complete: function () {},
        })
    }

    /**
     * 轮询微信绑定状态
     * @param {*} params 
     */
    pollingState() {
        const ts = this;
        
        const { handle } = this.props
        const t = setInterval(() => {
            const { flag } = this.state;
            ts.getBindState();
            // 绑定好就清空定时器，并手动调用提交按钮到完成这一步
            if (flag) {
                clearInterval(t);
                handle();
            }
        }, 1000);
    }

    getImg(){
        const _this = this
        $.ajax({
            url: urls.bindQrCode,
            type: "get",
            dataType: "json",
            success: function (response) {
                if (
                    response.resultCode === 0 &&
                    response.result.data
                ) {
                    _this.setState({
                        icon: response.result.data.qrCodeURL,
                        codeUrl: response.result.data.qrCodeContent,
                        wechat: response.result.data.wechat,
                    })
                } else {
                    // message.warning(response.errorMsg)
                }
            },
            error: function (xhr) {
                // message.warning("请求异常")
            },
            complete: function () {},
        })
    }

    componentDidMount() {
        this.pollingState();
        this.getImg();
    }

    render() {
        const { wechat, icon, codeUrl } = this.state;
        const dom  = <div>
                <SuiForm
                    bind={postStore}
                    ref={(node) => {
                        this.bindWechatForm = node
                    }}
                >
                    <div style={{ textAlign: "center" }}>
                        <img
                            style={{ width: 160, height: 160 }}
                            alt="扫描二维码绑定微信账号"
                            src={`${baseurl}${subPath}${icon}`}
                        />
                        <div style={{ padding: 15, fontSize: 14 }}>
                            请使用微信“扫一扫”扫描二维码绑定微信账号，否则无法登录统一身份认证。
                            <p
                                style={{
                                    color: "red",
                                    fontSize: 12,
                                    paddingTop: 8,
                                }}
                            >
                                * 移动端请长按保存二维码，然后打开微信扫一扫绑定
                            </p>
                            {wechat ? (
                                <p>
                                    或者点击<a href={codeUrl}>这里</a>去绑定
                                </p>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                </SuiForm>
            </div> 


            let el = null;
            if (wechat) {
                el = (
                    <div style={{ margin: 16,textAlign:'center' }}>
                        <Button
                            type="primary"
                            onClick={() => (window.location.href = codeUrl)}
                        >
                            绑定微信
                        </Button>
                    </div>
                )
            } else {
                el = dom;
            }
        return <div>{icon ? el : ""}</div>
    }
}
export default BindEmail
